/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FcbExportCentrePermissionDto
 */
export interface FcbExportCentrePermissionDto {
    /**
     * 
     * @type {boolean}
     * @memberof FcbExportCentrePermissionDto
     */
    selected?: boolean;
    /**
     * 
     * @type {number}
     * @memberof FcbExportCentrePermissionDto
     */
    idexport?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FcbExportCentrePermissionDto
     */
    idcentre?: number;
    /**
     * 
     * @type {string}
     * @memberof FcbExportCentrePermissionDto
     */
    nom?: string | null;
}

/**
 * Check if a given object implements the FcbExportCentrePermissionDto interface.
 */
export function instanceOfFcbExportCentrePermissionDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbExportCentrePermissionDtoFromJSON(json: any): FcbExportCentrePermissionDto {
    return FcbExportCentrePermissionDtoFromJSONTyped(json, false);
}

export function FcbExportCentrePermissionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbExportCentrePermissionDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'selected': !exists(json, 'selected') ? undefined : json['selected'],
        'idexport': !exists(json, 'idexport') ? undefined : json['idexport'],
        'idcentre': !exists(json, 'idcentre') ? undefined : json['idcentre'],
        'nom': !exists(json, 'nom') ? undefined : json['nom'],
    };
}

export function FcbExportCentrePermissionDtoToJSON(value?: FcbExportCentrePermissionDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'selected': value.selected,
        'idexport': value.idexport,
        'idcentre': value.idcentre,
        'nom': value.nom,
    };
}

